module.exports = __webpack_public_path__ + "static/media/peluquera1.41c86ef3.jpeg";